import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";
import { ExpandMore, History as HistoryIcon } from "@material-ui/icons";
import { formatPbhHistoryRow } from "../utils/formatters";

interface PbhHistoryAccordionProps {
  classes: any;
  pbhHistoryLoading: boolean;
  pbhHistoryData: any[];
}

const PbhHistoryAccordion: React.FC<PbhHistoryAccordionProps> = ({ classes, pbhHistoryLoading, pbhHistoryData }) => {
  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />} className={classes.accordionSummary}>
        <Typography className={classes.cardTitle}>
          <HistoryIcon /> PBH Unserviceable History
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {pbhHistoryLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" width="100%">
            <CircularProgress />
          </Box>
        ) : pbhHistoryData.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" width="100%">
            <Typography color="textSecondary">No PBH history data available</Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0}>
            <Table className={classes.historyTable}>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell>
                    <strong>TSO</strong>
                  </TableCell>
                  <TableCell>
                    <strong>TSR</strong>
                  </TableCell>
                  <TableCell>
                    <strong>TSN</strong>
                  </TableCell>
                  <TableCell>
                    <strong>CSO</strong>
                  </TableCell>
                  <TableCell>
                    <strong>CSR</strong>
                  </TableCell>
                  <TableCell>
                    <strong>CSN</strong>
                  </TableCell>
                  <TableCell>
                    <strong>DSR</strong>
                  </TableCell>
                  <TableCell>
                    <strong>DSN</strong>
                  </TableCell>
                  <TableCell>
                    <strong>DOM</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Removal Reason Detail</strong>
                  </TableCell>
                  <TableCell>
                    <strong>NHA</strong>
                  </TableCell>
                  <TableCell>
                    <strong>NLA</strong>
                  </TableCell>
                  <TableCell>
                    <strong>AD/SB/MOD</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Created By</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Updated By</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Created Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Updated Date</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pbhHistoryData.map((history, index) => {
                  const formattedRow = formatPbhHistoryRow(history);
                  return (
                    <TableRow key={index} hover>
                      <TableCell>{formattedRow.tso}</TableCell>
                      <TableCell>{formattedRow.tsr}</TableCell>
                      <TableCell>{formattedRow.tsn}</TableCell>
                      <TableCell>{formattedRow.cso}</TableCell>
                      <TableCell>{formattedRow.csr}</TableCell>
                      <TableCell>{formattedRow.csn}</TableCell>
                      <TableCell>{formattedRow.dsr}</TableCell>
                      <TableCell>{formattedRow.dsn}</TableCell>
                      <TableCell>{formattedRow.dom}</TableCell>
                      <TableCell>{formattedRow.removalReasonDetail}</TableCell>
                      <TableCell>{formattedRow.nha}</TableCell>
                      <TableCell>{formattedRow.nla}</TableCell>
                      <TableCell>{formattedRow.adSbMod}</TableCell>
                      <TableCell>{formattedRow.createdBy}</TableCell>
                      <TableCell>{formattedRow.updatedBy}</TableCell>
                      <TableCell>{formattedRow.createdDate}</TableCell>
                      <TableCell>{formattedRow.updatedDate}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default PbhHistoryAccordion;
